import { render } from "./dayNavigator.vue?vue&type=template&id=04332a70&ts=true"
import script from "./dayNavigator.vue?vue&type=script&lang=ts"
export * from "./dayNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__